export const UpdatePartBOMValidation = (formData) => {
    const errors = {};
    debugger;
    if (formData.bomID==="0") {
        errors.bomID = 'This field is required';
    }
    

    return errors;
};
